// components/AboutUsContent.tsx
import React from "react";

interface AboutUsProps {
  fontSize?: "small" | "medium" | "large";
}

const fontSizeMap = {
  small: "text-sm",
  medium: "text-base",
  large: "text-lg",
};

const AboutUsContent: React.FC<AboutUsProps> = ({ fontSize = "medium" }) => {
  const textSize = fontSizeMap[fontSize];

  return (
    <div className="bg-blue-900">
      <div className={`p-6 max-w-4xl mx-auto ${textSize}  text-white` }>
      <h1 className="text-3xl font-bold text-center mb-6 text-white">About DHIKROO International Islamic Academy</h1>

      <p className="mb-4">
        <strong>DHIKROO International Islamic Academy</strong> is a global Islamic educational institution located in Ilorin, Nigeria. Our goal is to foster the development of well-rounded individuals who are not only academically sound but also spiritually grounded.
      </p>

      <img
        src="/images/Logo2.jpeg"
        alt="DHIKROO Academy"
        className="rounded-lg mb-6 w-full h-auto shadow-md"
      />

      <h2 className="text-2xl font-semibold mb-4">Our Philosophy</h2>
      <p className="mb-4">
        Dhikroo International Islamic Academy was established in the year 2008 and was initially named MANAARAHOF KNOWLEDGE as a Quran reading and memorization school which was later upgraded in the year 2009 to enhance a standard level of western education to enable our children be internationally well presentable for brighter future. While, was registered under CAC with the name DHIKROO INTERNATIONAL ISLAMIC ACADEMY and then, approved by the Kwara State Government in the year 2011. The school started its journey from Erin-ile Crescent Area, off Stadium Road, Ilorin. Then, later moved down to Oko-Erin Road, Ilorin
      </p>

      <blockquote className="border-l-4 border-blue-500 pl-4 italic text-white mb-4">
        “Knowledge without ethics is a sword in the hands of a madman.”
      </blockquote>

      <ul className="list-disc pl-6 mb-6">
        <li>Providing high-quality Islamic and secular education.</li>
        <li>Encouraging lifelong learning and curiosity.</li>
        <li>Building strong moral character and responsibility.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">Why Choose DHIKROO?</h2>
      <p>
        Our integrated curriculum combines the best of both worlds—Islamic values and modern academic excellence. We nurture students to be confident, articulate, and committed to community growth and global citizenship.
      </p>
    </div>
    </div>
  );
};

export default AboutUsContent;
